import React from "react";
import config from "./config";

const Header = () => {
  return (
    <div className="header">
      <div id="logo">
        <a href={window.location.href}>
          <img
            src="images/FreedomCorr_logo.png"
            alt="logo"
            width={180}
            height={70}
          />
        </a>
      </div>
      <ul id="menu">
        <li>
          <a href={window.location.origin}>Home</a>
        </li>
        <li>
          <a
            href={
              config.appBaseUrl + "wps/portal/correspondent/correspondent/help"
            }
          >
            Help/FAQ
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Header;
